import * as Html from "../../util/Html.ts";
export {initDom}
Html.registerWidget('widget/form/submitonanychange',{initDom:initDom})

function initDom(node: HTMLElement){
  // Sélectionner tous les éléments input, select et textarea
  const inputs = node.querySelectorAll('input, select, textarea');

  inputs.forEach(input => {
    input.addEventListener('change', function(){
      // Déclencher l'événement submit sur le formulaire
      const submitEvent = new Event('submit', {
        bubbles: true,
        cancelable: true
      });
      node.dispatchEvent(submitEvent);
    });
  });
}